// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.cron-editor {
  display: flex;
  flex-direction: column;
  background: var(--preset-card, #073642);
  border: 1px solid rgba(128, 128, 128, 0.3);
  border-radius: 8px;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.3);
  width: 400px;
  max-width: 95vw;
}
.cron-editor.inline {
  width: 100%;
  max-width: 100%;
  background: transparent;
  border: none;
  border-radius: 0;
  box-shadow: none;
}
.cron-editor.inline .content {
  padding: 8px 0 4px;
  gap: 10px;
}

.header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 16px;
  border-bottom: 1px solid rgba(128, 128, 128, 0.2);
}
.header .title {
  font-weight: 500;
  font-size: 14px;
}
.header button.mat-mdc-icon-button {
  width: 28px;
  height: 28px;
  padding: 5px 0 0 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}
.header button.mat-mdc-icon-button .mat-icon {
  font-size: 18px;
}

.content {
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.label {
  font-size: 12px;
  opacity: 0.7;
  margin-bottom: 8px;
  display: block;
}

.presets .preset-buttons {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
}
.presets .preset-buttons button {
  font-size: 11px;
  padding: 4px 10px;
  min-width: unset;
  line-height: 1.4;
  height: auto;
}
.presets .preset-buttons button.active {
  background: var(--preset-primary, #2aa198);
  color: white;
}

.expression-editor .parts {
  display: flex;
  gap: 8px;
}
.expression-editor .parts .part {
  flex: 1;
  display: flex;
  flex-direction: column;
}
.expression-editor .parts .part label {
  font-size: 10px;
  opacity: 0.6;
  margin-bottom: 4px;
}
.expression-editor .parts .part input {
  background: rgba(0, 0, 0, 0.2);
  border: 1px solid rgba(128, 128, 128, 0.3);
  border-radius: 4px;
  padding: 6px 8px;
  color: inherit;
  font-family: monospace;
  font-size: 13px;
  text-align: center;
  width: 100%;
  box-sizing: border-box;
}
.expression-editor .parts .part input:focus {
  outline: none;
  border-color: var(--preset-primary, #2aa198);
}

.preview {
  background: rgba(0, 0, 0, 0.15);
  padding: 12px;
  border-radius: 4px;
}
.preview code {
  font-family: monospace;
  font-size: 14px;
  background: rgba(0, 0, 0, 0.2);
  padding: 4px 8px;
  border-radius: 3px;
  margin-right: 12px;
}
.preview .human-readable {
  font-size: 12px;
  opacity: 0.8;
}

.actions {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 12px 16px;
  border-top: 1px solid rgba(128, 128, 128, 0.2);
}
.actions .spacer {
  flex: 1;
}
.actions .spin {
  animation: spin 1s linear infinite;
  font-size: 18px;
  width: 18px;
  height: 18px;
  margin-right: 4px;
}

@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}`, "",{"version":3,"sources":["webpack://./src/app/components/strategy-grid/cron-editor/cron-editor.component.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,sBAAA;EACA,uCAAA;EACA,0CAAA;EACA,kBAAA;EACA,yCAAA;EACA,YAAA;EACA,eAAA;AACF;AACE;EACE,WAAA;EACA,eAAA;EACA,uBAAA;EACA,YAAA;EACA,gBAAA;EACA,gBAAA;AACJ;AACI;EACE,kBAAA;EACA,SAAA;AACN;;AAIA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,kBAAA;EACA,iDAAA;AADF;AAGE;EACE,gBAAA;EACA,eAAA;AADJ;AAIE;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;AAFJ;AAII;EACE,eAAA;AAFN;;AAOA;EACE,aAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;AAJF;;AAOA;EACE,eAAA;EACA,YAAA;EACA,kBAAA;EACA,cAAA;AAJF;;AAQE;EACE,aAAA;EACA,eAAA;EACA,QAAA;AALJ;AAOI;EACE,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,gBAAA;EACA,YAAA;AALN;AAOM;EACE,0CAAA;EACA,YAAA;AALR;;AAYE;EACE,aAAA;EACA,QAAA;AATJ;AAWI;EACE,OAAA;EACA,aAAA;EACA,sBAAA;AATN;AAWM;EACE,eAAA;EACA,YAAA;EACA,kBAAA;AATR;AAYM;EACE,8BAAA;EACA,0CAAA;EACA,kBAAA;EACA,gBAAA;EACA,cAAA;EACA,sBAAA;EACA,eAAA;EACA,kBAAA;EACA,WAAA;EACA,sBAAA;AAVR;AAYQ;EACE,aAAA;EACA,4CAAA;AAVV;;AAiBA;EACE,+BAAA;EACA,aAAA;EACA,kBAAA;AAdF;AAgBE;EACE,sBAAA;EACA,eAAA;EACA,8BAAA;EACA,gBAAA;EACA,kBAAA;EACA,kBAAA;AAdJ;AAiBE;EACE,eAAA;EACA,YAAA;AAfJ;;AAmBA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,kBAAA;EACA,8CAAA;AAhBF;AAkBE;EACE,OAAA;AAhBJ;AAmBE;EACE,kCAAA;EACA,eAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;AAjBJ;;AAqBA;EACE;IAAO,uBAAA;EAjBP;EAkBA;IAAK,yBAAA;EAfL;AACF","sourcesContent":[".cron-editor {\n  display: flex;\n  flex-direction: column;\n  background: var(--preset-card, #073642);\n  border: 1px solid rgba(128, 128, 128, 0.3);\n  border-radius: 8px;\n  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.3);\n  width: 400px;\n  max-width: 95vw;\n\n  &.inline {\n    width: 100%;\n    max-width: 100%;\n    background: transparent;\n    border: none;\n    border-radius: 0;\n    box-shadow: none;\n\n    .content {\n      padding: 8px 0 4px;\n      gap: 10px;\n    }\n  }\n}\n\n.header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 12px 16px;\n  border-bottom: 1px solid rgba(128, 128, 128, 0.2);\n\n  .title {\n    font-weight: 500;\n    font-size: 14px;\n  }\n\n  button.mat-mdc-icon-button {\n    width: 28px;\n    height: 28px;\n    padding: 5px 0 0 0;\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n\n    .mat-icon {\n      font-size: 18px;\n    }\n  }\n}\n\n.content {\n  padding: 16px;\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n.label {\n  font-size: 12px;\n  opacity: 0.7;\n  margin-bottom: 8px;\n  display: block;\n}\n\n.presets {\n  .preset-buttons {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 6px;\n\n    button {\n      font-size: 11px;\n      padding: 4px 10px;\n      min-width: unset;\n      line-height: 1.4;\n      height: auto;\n\n      &.active {\n        background: var(--preset-primary, #2aa198);\n        color: white;\n      }\n    }\n  }\n}\n\n.expression-editor {\n  .parts {\n    display: flex;\n    gap: 8px;\n\n    .part {\n      flex: 1;\n      display: flex;\n      flex-direction: column;\n\n      label {\n        font-size: 10px;\n        opacity: 0.6;\n        margin-bottom: 4px;\n      }\n\n      input {\n        background: rgba(0, 0, 0, 0.2);\n        border: 1px solid rgba(128, 128, 128, 0.3);\n        border-radius: 4px;\n        padding: 6px 8px;\n        color: inherit;\n        font-family: monospace;\n        font-size: 13px;\n        text-align: center;\n        width: 100%;\n        box-sizing: border-box;\n\n        &:focus {\n          outline: none;\n          border-color: var(--preset-primary, #2aa198);\n        }\n      }\n    }\n  }\n}\n\n.preview {\n  background: rgba(0, 0, 0, 0.15);\n  padding: 12px;\n  border-radius: 4px;\n\n  code {\n    font-family: monospace;\n    font-size: 14px;\n    background: rgba(0, 0, 0, 0.2);\n    padding: 4px 8px;\n    border-radius: 3px;\n    margin-right: 12px;\n  }\n\n  .human-readable {\n    font-size: 12px;\n    opacity: 0.8;\n  }\n}\n\n.actions {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 12px 16px;\n  border-top: 1px solid rgba(128, 128, 128, 0.2);\n\n  .spacer {\n    flex: 1;\n  }\n\n  .spin {\n    animation: spin 1s linear infinite;\n    font-size: 18px;\n    width: 18px;\n    height: 18px;\n    margin-right: 4px;\n  }\n}\n\n@keyframes spin {\n  from { transform: rotate(0deg); }\n  to { transform: rotate(360deg); }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
